export const presentations = [
  {
    path: '/presentations',
    component: () => import(/* webpackChunkName: "presentations" */ '@/views/presentations/Presentations'),
  },
]
